<template>
 <div class="slide-gallery">
  <div class="freight-logo">
    <img src="../../../static/img/freight-intelligence-logo.png" />
  </div>
  <div class="slide-gallery-msg">
    {{ $t('slide_gallery_msg') }}
  </div>
  <div class="slide-messages">
    <span class="slide-message pos-1">
      {{ $t('slide_update_status') }}
    </span>
    <span class="slide-message pos-2">
      {{ $t('slide_centralize_info') }}
    </span>
    <span class="slide-message pos-3">
      {{ $t('slide_automate_tracking') }}
    </span>
    <span class="slide-message pos-4">
      {{ $t('slide_create_alerts') }}
    </span>
  </div>
  <a class="download-flyer" download href="/static/docs/Freight Intelligence.pdf">
    <button class="button lime">
      {{$t('download_flyer')}}
    </button>
  </a>
</div>
</template>
<script>
export default {
  name: 'slide-gallery'
}
</script>
<style lang="scss">
  @import '../../assets/scss/variables.scss';
.slide-gallery {
  background-image:  url("/../../../static/img/presentation.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  padding-top: 3em;
  height: 45em;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
}
.download-flyer {
  position: absolute;
  right: .5em;
  bottom: .5em;
}
.freight-logo {
  max-width: 88%;
  width: 30em;
  margin: 3em 6%;
  filter:brightness(100);
}
.slide-gallery-msg {
  color: white;
  box-sizing: border-box;
  display: inline-block;
  font-size: 4em;
  margin-left: 6%;
  width: 17em;
  max-width: 94%;
  font-family: MuseoSans-900;
  text-transform: uppercase;
  line-height: 1em;
}
.slide-messages {
  flex: 1;
  margin: 0 6%;
  position: relative;
  .slide-message {
    color: $lime;
    font-size: 3em;
    font-family: MuseoSans-900;
    text-transform: uppercase;
    line-height: 1em;
    display: block;
    width: 16em;
    max-width: 100%;
    position: absolute;
    opacity: 0;
	  animation: message 12s infinite;
    &.pos-2 {
      animation-delay: 3s;
    }
    &.pos-3 {
      animation-delay: 6s;
    }
    &.pos-4 {
      animation-delay: 9s;
    }
  }
}

@keyframes message{
  5%, 25% {
    opacity: 1;
		transform: translateY(2em);
	}

	30%, 50% {
    opacity: 0;
		transform: translateY(6em);
	}

	55%, 75% {
    opacity: 0;
		transform: translateY(-2em);
	}

  80%, 100%, 0% {
    opacity: 0;
    transform: translateY(-2em);
  }
}
@media screen and (max-width: 900px) {
  .slide-gallery-msg {
    font-size: calc(1.8em + 3vw)
  }
  .slide-messages {
    .slide-message {
      font-size: calc(1.3em + 3vw);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/product/SlideGallery.vue